import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import './styles/critical.css'  // Import critical CSS before other styles
import './i18n/config';

// Registra o service worker para atualização automática via VitePWA.
// Certifique-se de que o VitePWA está instalado e configurado no seu projeto.
import { registerSW } from 'virtual:pwa-register';

const updateSW = registerSW({
  onNeedRefresh() {
    // Quando uma nova versão for encontrada, pergunta ao usuário se deseja atualizar.
    if (confirm('Nova versão disponível. Atualizar agora?')) {
      updateSW(true);
    }
  },
  onOfflineReady() {
    // Essa callback é chamada quando o app está pronto para funcionar offline.
    console.log('Aplicação pronta para funcionar offline.');
  }
});

/* comentário */
ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);